import gql from "graphql-tag";

export const POSTS_QUERY = gql`
query posts($instructorId: String, $forGroupId: String, $after: String, $userId: ID, $forUserId: String, $email: String, $groupType: String, $title: String, $content: String, $workoutBlockIds: [String], $nutritionblockIds: [String]) {
  posts(forGroupId: $forGroupId, forUserId: $forUserId, userId: $userId, first: 10, after: $after, user_Email_Icontains: $email, group_Type: $groupType, group_Title_Icontains: $title, content_Icontains: $content, forInstructorId: $instructorId, group_NutritionBlock_Id_In: $nutritionblockIds, group_WorkoutBlock_Id_In: $workoutBlockIds){
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        id
        likeCount
        commentCount
        id
          createdAt
          content
          url
          allowSharing
          user {
            id
            firstName
            lastName
            userProfile {
              id
              profilePicture
            }
          }
          postattachmentSet {
            id
            file
            type
            timeInSeconds
          }
        userPostLike {
          id
        }
        group {
          id
          title
        }
        
      }
      
    }   
  }
}`

export const POST_QUERY = gql`
query post($id: ID!) {
  post(id: $id){
    id
    likeCount
    commentCount
    id
      createdAt
      content
      url
      allowSharing
      user {
        id
        firstName
        lastName
        userProfile {
          id
          profilePicture
        }
      }
      postattachmentSet {
        id
        file
        type
        timeInSeconds
      }
    userPostLike {
      id
    }
    group {
      id
      title
    }
    
  }
      
}`


export const COMMENTS_QUERY = gql`
query comments($postId: ID, $after: String) {
  comments(postId: $postId, after: $after){
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        id
        text
        parentComment {
          id
        },
        user {
          id
          firstName
          lastName
          userProfile {
            id
            profilePicture
          }
        }
      }
    }   
  }
}`

export const LEAD_INSTRUCTOR_WITH_BLOCKS_QUERY = gql`
  query leadInstructors {
    leadInstructors {
      id
      firstName
      lastName
    }
    workoutBlocks {
      edges {
        node {
          id
          title
        }
      }
    }
    nutritionBlocks {
      edges {
        node {
          id
          title
        }
      }
    }
  }
`;